import React, { useContext, useEffect, useRef, useState, useMemo } from "react";
import { ThemeContext } from "styled-components";
import styled from "styled-components";
import closeIcon from '../Assets/icon/closeIcon.png'
import Col from './Column'
import Text from './Text'
import Image from './Image'
import StyledButton from "./Button";
import nextIcon from '../Assets/icon/nextIcon.png'
const StyledModalWrapper = styled.div`
  position: fixed !important;
  clear: both;
  background-color: rgba(47, 79, 79, 0.514);
  top: 0;
  left: 0;
  z-index: 306;
  width: 100vw !important;
  height: 100vh;
  opacity : ${props => props.show === true ? 1 : 0};
  display: ${props => props.show === true ? 'flex' : 'none'};
  transition: transform 50ms cubic-bezier(0, 0, 0.2, 1) 0ms;
   @media screen and (max-width: 768px) {
    min-height: 100%;
    height: 100%;
    max-height : 100%;
  }
`
const StyledModalContainer = styled.div`
flex-direction: column;
  align-self: flex-end;
  background-color: white;
  position: relative !important;
  /* left: 0vw !important; */
  width: 100vw !important;
  height: calc(100vh - 70px);
  /* bottom: 0px !important; */
  z-index: 150;
  border-radius : 25px 25px 0px 0px;
  transition: transform 370ms cubic-bezier(0, 0, 0.2, 1) 50ms;
  overflow-y:auto;
   ::-webkit-scrollbar {
      display:none
  };
   &.open {
    transform: translateY(0%);
  }
  &.close {
    transform: translateY(100%);
  }
   @media screen and (max-width: 768px) {
    position : fixed !important;
    min-height: 100%;
    height: 100%;
    max-height : 100%;
    border-radius: 0px 0px 0px 0px !important;
  }
`;
const HeaderStyle = {

}
const Header = styled(Col)`
height: 90px;
    flex-Direction: column;
    @media screen and (max-width: 768px) {
        height: 60px
    }
`
const HeaderTitleBarStyle = {
    height: '80%',
    fontSize: '18px',
}
const HeaderActionButtonStyle = {
    cursor: 'pointer',
    height: '100%'
}
const HeaderCancelButtonStyle = {
    // backgroundColor: 'red',
}
const HeaderCancelButtonIconStyle = {
    width: '15px',
    height: '15px',
    cursor: 'pointer',
}
const HeaderStepBarContainerStyle = {
    flexDirection: 'column',
    height: 'auto',
}
const HeaderStepBarLineStyle = {
    display: 'flex',
    width: '100%',
    height: '1px',
    backgroundColor: '#e0e0e0',
}
const HeaderStepContainerStyle = {
    position: 'absolute !important',
    justifyContent: 'space-evenly',
}
const HeaderStepStyle = (theme) => {
    return ({
        width: '15px',
        height: '15px',
        borderRadius: '8px',
        border: `1px solid ${theme.primary}`,
        backgroundColor: 'white',
    })
}
const Container = styled(Col)`
    width: 100%;
    height: calc(100% - 160px);
    min-height: calc(100% - 160px);
     overflow-y:auto;
   ::-webkit-scrollbar {
      display:none
  };
     @media screen and (max-width: 768px) {
        min-height: calc(100% - 70px);
        height: calc(100% - 70px);
        align-items : flex-start;
        margin-top:0px;
     }
`
const Footer = styled(Col)`
  width: 100%;
  min-height : 70px;
    max-height: 70px;
    z-index: 105;
    background-color: white;
    box-shadow: 0 -1px 4px 0 #dddddd;
bottom : 0px !important;
position : absolute !important;
     @media screen and (max-width: 768px) {
  min-height : 70px;
         height : 70px;
         max-height : 70px;
     };
`;
const FooterFirstSideContainerStyle = styled(Col)`
    height: 100%;
     @media screen and (max-width: 768px) {
       display : none
    };
`
const FooterSecondSideContainerStyle = styled(Col)`
    justify-content: flex-end;
    height: 100%;
     @media screen and (max-width: 768px) {
       button  {
           width : 100%;
           height : 40px
       }
    };
`
export const StyledModal = (props) => {
    const [show, setShow] =
        useState(props.visible);

    const {
        visible,
        totalStep,
        currentStep,
        modalTitle,
        hasHeaderAction,
        headerActionTitle,
        headerActionHandler,
        headerActionComponent,
        onClose,
        FooterActionDisable,
        FooterActionText,
        FooterActionLoading,
        FooterRightSideComponent,
        FooterLeftSideComponent,
        confirmHandler,
        confirmDisable,
        type
    } = props
    const theme = useContext(ThemeContext)
    const Step = Array(totalStep).fill([]).map((each, i) => i)
    useEffect(() => {
        setShow(visible);
    }, [visible]);
    useMemo(() => {
        if (visible === true) {
            document.body.style.overflowY = "hidden"
        } else {
            document.body.style.overflowY = "auto"
        }
    },
        [visible]
    )
    return (
        <StyledModalWrapper
            show={visible}
        // className={`${show ? 'openBackground' : 'closeBackground'}`}
        >
            <StyledModalContainer
                className={`${show ? 'open' : 'close'}`}
                shadow={theme.confirmBoxShadow}
            >
                <Header
                    xl={24} lg={24} md={24} sm={24} xs={24}
                    style={HeaderStyle}
                >
                    <Col
                        xl={24} lg={23} md={23} sm={23} xs={23}
                        style={HeaderTitleBarStyle}
                    >
                        <Col
                            style={HeaderActionButtonStyle}
                            xl={2}
                            lg={2}
                            md={2}
                            sm={4}
                            xs={4}
                        >
                            <Col
                                onClick={headerActionHandler}
                                style={{
                                    backgroundImage: !headerActionTitle && `url(${nextIcon})`,
                                    display: hasHeaderAction === false && 'none',
                                    minHeight: '20px',
                                    minWidth: headerActionTitle ? "100%" : '20px',
                                    height: '20px',
                                    width: headerActionTitle ? "100%" : '20px',
                                    backgroundSize: 'contain',
                                    fontWeight: headerActionTitle ? 400 : 800,
                                    fontSize: headerActionTitle && '12px'
                                }}
                            >
                                {headerActionTitle && headerActionTitle}
                            </Col>
                        </Col>
                        <Col
                            // className='o__Booking__Modal__Header__TitleBar__Title'
                            xl={20}
                            lg={20}
                            md={20}
                            sm={20}
                            xs={16}
                            style={
                                {
                                    height: '80%',
                                    fontSize: theme.fontSizeMd,
                                }
                            }
                        >
                            <Text>
                                {modalTitle}
                            </Text>
                        </Col>
                        <Col
                            style={HeaderCancelButtonStyle}
                            xl={2} lg={2} md={2}
                            sm={4}
                            xs={4}
                        >
                            <Image
                                style={HeaderCancelButtonIconStyle}
                                onClick={onClose}
                                src={closeIcon} />
                        </Col>
                    </Col>
                    <Col
                        xl={24} lg={24} md={24} sm={24} xs={24}
                        style={HeaderStepBarContainerStyle}
                    >
                        <span
                            style={HeaderStepBarLineStyle}
                        ></span>
                        <Col
                            style={HeaderStepContainerStyle}
                            xl={8} lg={8} md={8} sm={8} xs={8}
                        >
                            {Step.map((each, index) => {
                                return (
                                    <Col
                                        style={HeaderStepStyle(theme)}
                                        style={{
                                            backgroundColor: index === currentStep && `${theme.primary}`
                                        }}
                                    >
                                    </Col>
                                )
                            })}
                        </Col>
                    </Col>
                </Header>
                <Container
                    xl={24} lg={24} md={24} sm={24} xs={24}
                >
                    {props.children}
                </Container>
                <Footer
                    xl={24} lg={24} md={24} sm={24} xs={24}
                >
                    <FooterFirstSideContainerStyle
                        xl={11.5} lg={11} md={11} sm={11} xs={0}
                    >
                        {FooterRightSideComponent && <FooterRightSideComponent />}
                    </FooterFirstSideContainerStyle>
                    <FooterSecondSideContainerStyle
                        xl={11.5} lg={11} md={11} sm={11} xs={21}
                    >
                        {FooterLeftSideComponent && <FooterLeftSideComponent />}
                        <StyledButton
                            type={type}
                            primary
                            onClick={confirmHandler}
                            loading={FooterActionLoading}
                            disable={FooterActionDisable}
                        >{FooterActionText}</StyledButton>
                    </FooterSecondSideContainerStyle>
                </Footer>
            </StyledModalContainer>
        </StyledModalWrapper >
    )
}